import React from 'react';
import { useQueueOverview } from '../context/QueueOverviewContext';
import { useWebSocket } from '../context/WebSocketContext';
import { useTheme } from '../context/ThemeContext';

export default function FightDrainStatus() {
  const overview = useQueueOverview();
  const { fightStatus } = useWebSocket();
  const { theme } = useTheme();
  const kind = fightStatus === 20 ? 'upload' : fightStatus === 30 ? 'vote' : null;
  if (!kind || !overview?.[`${kind}Draining`]) return null;
  const pending = overview[`${kind}Pending`] || 0;
  const attention = overview[`${kind}Attention`] || 0;
  const seconds = Number(overview.nextVoteSeconds || 120);
  const nextDuration = seconds % 60 === 0 ? `${seconds / 60} 分钟` : `${seconds} 秒`;
  return <div className="pb-drain-status" role="status" data-stage-draining={kind} style={{ color: theme.textSecondary }}>
    <span>{kind === 'upload' ? '上传已截止' : '投票已截止'}，{pending > 0 ? `还有 ${pending} 项待完成` : '正在切换阶段'}</span>
    {attention > 0 && <span>其中 {attention} 项等待重试，超时自动取消</span>}
    <span>{kind === 'upload' ? `处理完后开始完整的 ${nextDuration}投票` : '处理完后自动公布结果'}</span>
  </div>;
}
